import { render } from "./Tabbar.vue?vue&type=template&id=1c659e4c&scoped=true"
import script from "./Tabbar.vue?vue&type=script&lang=js"
export * from "./Tabbar.vue?vue&type=script&lang=js"

import "./Tabbar.vue?vue&type=style&index=0&id=1c659e4c&scoped=true&lang=css"

import exportComponent from "/data/fe-node-modules/beta-ab/candao-h5-v6-phd/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1c659e4c"]])

export default __exports__